import { render, staticRenderFns } from "./OrderProgress.vue?vue&type=template&id=19d88cb1&scoped=true"
import script from "./OrderProgress.vue?vue&type=script&lang=js"
export * from "./OrderProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d88cb1",
  null
  
)

export default component.exports